var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 33,
    viewBox: "0 0 45 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0816 8.64409C45.0189 6.70679 45.0189 3.54312 43.0816 1.60581C41.1443 -0.331494 37.9806 -0.331494 36.0433 1.60581L16.8125 20.8367L8.95659 12.9808C7.01929 11.0435 3.85562 11.0435 1.91831 12.9808C-0.0189942 14.9181 -0.0189942 18.0818 1.91831 20.0191L13.2933 31.3941C15.2306 33.3314 18.3943 33.3314 20.3316 31.3941L43.0816 8.64409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.23facf4e3ca2949b5e69efb710f205f9.svg";
export { ForwardRef as ReactComponent };